import React, { Component } from 'react';
import './Login.css';
import {connect} from "react-redux";






class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            "email":"",
            "password": ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleChange(event) {

        const target = event.target;
        const name = target.name;

        this.setState({
            [name]:target.value
        });

    }


    handleSubmit(event){

        event.preventDefault();

        fetch('https://api.iondeveloper.com/admin/user/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"login",
                    "email": this.state.email,
                    "password": this.state.password
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            if (data.success){

                this.props.dispatch(
                    {
                        "type":"SET_USER_DATA",
                        "user": data.user
                    });
                this.props.history.push('/');
            } else {
                alert("Your username or password didn't work. Try again, or contact the devs and we can help ya out!");
            }

        }.bind(this));

    }





    render() {

        return (
            <div className="login-bg-color">
                <div className="login-comp">
                    <b>Ion Admin</b>
                    <div className="form-container login-form">
                        <form onSubmit={this.handleSubmit}>
                            <input className="standard-input" type="text" name="email" value={this.state.email} onChange={this.handleChange} placeholder="Email Address" />
                            <input className="standard-input" type="password" name="password" value={this.state.password} onChange={this.handleChange} placeholder="Password" />
                            <button type="submit" className="form-submit" >Sign In</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}






function mapStateToProps(state) {
    return {
        state: state.user
    };
}

export default connect(mapStateToProps)(Login);


// WEBPACK FOOTER //
// ./src/components/pages/Login/Login.js